module.exports = __webpack_public_path__ + "static/img/z_bg_bszn.7efe493.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhengwu/z_bg_bszn.png
// module id = hYFh
// module chunks = 1